export default __webpack_public_path__ + "static/media/TERMINAL_ICON_09.f627031a.svg";